var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoading === true)?_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"loading"},[_c('vue-loading',{attrs:{"type":"spiningDubbles","color":"#333","size":{ width: '50px', height: '50px'}}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }